export const PATH_DATA_ATTRIBUTE = 'data-cr-content-path';
export const CONTENT_DATA_ATTRIBUTE = 'data-cr-content';
export const WINDOW_DATA_PROPERTY_NAME = '__WTR_CR_DATA__';
export const HYDRATED_DATA_ATTRIBUTE = 'data-wtr-cr-hydrated';
export const HYDRATE_EVENT_NAME = 'wtr-cr-hydrate';
export const PAGE_ROOT_ID = 'wtr-cr-page-root';
